import { useEffect } from 'react';
import {
    useLocation,
    useNavigate,
    useParams
  } from "react-router-dom";

export const withJobDefaultRoute = (Component) =>  {
    const WithJobDefaultRouteWrapper = (props) => {
		const location = useLocation();
		const navigate = useNavigate();
		const params = useParams();
		const match = {
			path: location.pathname
		};
		
		useEffect(() => {
			// if the default page has been requested
			var defaultRegex = /\/jobtrack\/jobs\/(([1-9][0-9]*)|new)$/i;
			if (defaultRegex.test(match.path)) {
				navigate(match.path + '/Description', { replace: true });
			}
		});
		
		return (
			<Component
				location={location}
				navigate={navigate}
				params={params}
				match={match}
				{...props}
			/>
		);
    }
    return WithJobDefaultRouteWrapper;
}
